const DB_NAME = 'worldauto';
const STORE = 'pending_images';
const DB_VERSION = 1;
const LANGS = ['ru', 'en', 'ua', 'ge'];
const TTL_MS = 7 * 24 * 60 * 60 * 1000;

const hasIDB = () => typeof window !== 'undefined' && 'indexedDB' in window;

let dbPromise = null;

export const bucketFromPath = (pathname) => {
    if (!pathname) return 'advert';
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length && LANGS.includes(segments[0])) segments.shift();
    return segments.join('/') || 'advert';
};

const openDb = () => {
    if (!hasIDB()) return Promise.resolve(null);
    if (dbPromise) return dbPromise;

    dbPromise = new Promise((resolve) => {
        let req;
        try {
            req = indexedDB.open(DB_NAME, DB_VERSION);
        } catch {
            resolve(null);
            return;
        }
        req.onupgradeneeded = () => {
            const db = req.result;
            if (!db.objectStoreNames.contains(STORE)) {
                db.createObjectStore(STORE, { keyPath: 'bucket' });
            }
        };
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => resolve(null);
    });
    return dbPromise;
};

const run = (mode, exec) =>
    openDb().then(
        (db) =>
            new Promise((resolve) => {
                if (!db) {
                    resolve(null);
                    return;
                }
                let result = null;
                let t;
                try {
                    t = db.transaction(STORE, mode);
                } catch {
                    resolve(null);
                    return;
                }
                exec(t.objectStore(STORE), (r) => {
                    result = r;
                });
                t.oncomplete = () => resolve(result);
                t.onerror = () => resolve(null);
                t.onabort = () => resolve(null);
            }),
    );

export const savePendingImages = (bucket, urls) => {
    if (!bucket) return Promise.resolve(null);
    return run('readwrite', (store) => {
        store.put({
            bucket,
            urls: Array.isArray(urls) ? urls : [],
            savedAt: Date.now(),
        });
    });
};

export const loadPendingImages = (bucket) => {
    if (!bucket) return Promise.resolve([]);
    return run('readonly', (store, setRes) => {
        const r = store.get(bucket);
        r.onsuccess = () => {
            const record = r.result;
            const urls = Array.isArray(record?.urls) ? record.urls : [];
            const savedAt = Number(record?.savedAt) || 0;
            if (urls.length && savedAt && Date.now() - savedAt > TTL_MS) {
                setRes([]);
                return;
            }
            setRes(urls);
        };
    }).then((v) => v || []);
};

export const clearPendingImages = (bucket) => {
    if (!bucket) return Promise.resolve(null);
    return run('readwrite', (store) => {
        store.delete(bucket);
    });
};

export const clearAllPendingImages = () =>
    run('readwrite', (store) => {
        store.clear();
    });
